module.exports = __webpack_public_path__ + "img/Slot-Games.ccf3217.png";